module.exports = {"id":"210423","name":"Albert Rusnák","rating":"74","photo":"./data/images/photos/3/210423.png","club":{"name":"Real Salt Lake","logo":"./data/images/clubs/RealSaltLake.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlbertRusnak0.json
// module id = 160
// module chunks = 0